/**
 * Copyright 2016 xdot GmbH
 * Author: Carsten Hibbeler
 * Date: 23.02.2016
 */
import { ActionTypesCommon, ComputedQueryParamsDataStore, RemoteDataStore } from 'plugin/liferay-widgets-react-web';
import { ClassNames } from '../constants/Constants';


export default class BomListStore extends ComputedQueryParamsDataStore {

    constructor(Dispatcher) {
        super(Dispatcher, undefined, undefined, undefined);
    }

    getDataClassNames(d) {
        if (d && d.item && Array.isArray(d.item)) {
            return d.item.reduce((acc, curr, idx) => {
                const className = curr.__type;
                if (acc.lastIndexOf(className)>=0) {
                    acc.push(className);
                }
                return acc;                                                 
            }, [  ]);
        } else {
            if (d && d.item) {
                return [ d.item.__type ];
            }
        }
        return [];
    }

    extendedWebsocketModelUpdate(remote, wsUpdate) {

        let newRemote;

        newRemote = this.handleObjectUpdates(wsUpdate, remote, newRemote);
        newRemote = this.handleTimeSeriesUpdates(wsUpdate, remote, newRemote);

        return newRemote || remote;
    }

    handleObjectUpdates(wsUpdate, remote, newRemote) {
        if (!wsUpdate.labels) {
            const storeRemoteEntries = RemoteDataStore.remoteStatetoDataArray(remote);
            if (storeRemoteEntries && storeRemoteEntries.length > 0) {
                storeRemoteEntries.forEach(remoteEntry => {
                    if (remoteEntry && remoteEntry.item &&  Array.isArray(remoteEntry.item)) {
                        return remoteEntry.item.map(bomItem => {
                            const bomClassName = bomItem.__type;

                            //Is same type or attached to the same type? AND is the updatedObject or attached to it?
                            if (bomClassName === wsUpdate.type || (wsUpdate.metadata && bomClassName === wsUpdate.metadata.attachedClassName)) {
                                if (bomItem.id === wsUpdate.id || (wsUpdate.metadata && bomItem.id === wsUpdate.metadata.attachedClassPK)) {
                                    let newItem = RemoteDataStore.invalidateData(remoteEntry);
                                    if (!newRemote) {
                                        newRemote = (newRemote || (newRemote = { ...remote }));
                                    }
                                    newRemote[ remoteEntry.name ] = newItem;
                                }
                            }

                        });
                    }
                });
            }

            return newRemote;
        }
    }

    handleTimeSeriesUpdates(wsUpdate, remote, newRemote) {
        if (wsUpdate.labels) {
            if (wsUpdate.labels.gaugingStationId > 0 || wsUpdate.labels.frbId > 0 || wsUpdate.labels.precipitationStationId > 0) {
                const storeRemoteEntries = RemoteDataStore.remoteStatetoDataArray(remote);
                if (storeRemoteEntries && storeRemoteEntries.length > 0) {
                    storeRemoteEntries.forEach(remoteEntry => {
                        if (remoteEntry.item) {
                            if (Array.isArray(remoteEntry.item)) {
                                remoteEntry.item.forEach(fliwasBom => {
                                    if (fliwasBom.id == (wsUpdate.labels.gaugingStationId || wsUpdate.labels.frbId || wsUpdate.labels.precipitationStationId)) {
                                        let newItem = RemoteDataStore.invalidateData(remoteEntry);
                                        if (!newRemote) {
                                            newRemote = (newRemote || (newRemote = { ...remote }));
                                        }
                                        newRemote[ remoteEntry.name ] = newItem;
                                    }
                                });
                                //Dont refresh list, only because a measurement of an item has changed
                            } else {
                                if (remoteEntry.item.id == (wsUpdate.labels.gaugingStationId || wsUpdate.labels.frbId || wsUpdate.labels.precipitationStationId)) {
                                    let newItem = RemoteDataStore.invalidateData(remoteEntry);
                                    if (!newRemote) {
                                        newRemote = (newRemote || (newRemote = { ...remote }));
                                    }
                                    newRemote[ remoteEntry.name ] = newItem;
                                }
                            }
                        }
                    });
                }
            }
        }
        return newRemote;
    }

    reduce(state, action) {

        if (!action.meta || !action.meta.className) {

            switch (action.type) {
                case ActionTypesCommon.DATA_LIST_INIT:
                    return this.initList(state, action.meta.name, action.payload, this.defaultListData);

                case ActionTypesCommon.DATA_ITEM_INIT:
                    return this.initItem(state, action.meta.name, action.payload, this.defaultItemData);

                case ActionTypesCommon.DATA_REMOVE:
                    return this.removeRemoteData(state, action.meta.name);
            }
        }

        return super.reduce(state, action);
    }
}



// WEBPACK FOOTER //
// ./js/stores/BomListStore.js